import { render, staticRenderFns } from "./ResourcesFileView.vue?vue&type=template&id=80605052&scoped=true"
import script from "./ResourcesFileView.vue?vue&type=script&lang=js"
export * from "./ResourcesFileView.vue?vue&type=script&lang=js"
import style0 from "./ResourcesFileView.vue?vue&type=style&index=0&id=80605052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80605052",
  null
  
)

export default component.exports